module.exports = __webpack_public_path__ + "img/Big_Arts_Yokel@1x.afd39f6f.png";